export const MAX_AMOUNT_OF_MATRESSES_PER_ORDER = 6;
export const MAX_AMOUNT_OF_FRAMES_PER_ORDER = 6;
